<template>
    <div class="documentsSection frame">
        <PulseLoader v-if="documentsLoading" size="8px" color="#00B2FF"/>
        <div v-else>
            <h3>{{'components/sidebar/documents.title' | trans}}</h3>
            <div class="docs">
                <a class="doc" :href="document.link" target="_blank" v-for="document in documents">
                    <span class="block date">{{document.subtitle}}</span>
                    <h4 class="title">{{document.title}}</h4>
                    <span class="block subtitle">{{document.description}}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import {mapActions, mapState} from 'vuex';
    export default {
        data: ()=>{
            return {
                documents: []
            }
        },
        components: {PulseLoader},
        methods: {},
        computed: {
            ...mapState(['documentsLoading', 'user'])
        },
		watch:{
          'user.documents':{
              immediate: true,
			  handler: function (val) {
                  this.documents = val;
              }
		  }
		},
        created(){
            this.documents = this.user.documents;
        }
    }
</script>
